import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="text-8xl font-bold text-red-600">404</div>
        <h1 className="text-2xl font-bold text-gray-900">Page Not Found</h1>
        <p className="text-gray-600">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Button asChild className="bg-red-600 hover:bg-red-700 text-white">
            <Link to="/"><Home className="h-4 w-4 mr-2" /> Go Home</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/contact"><ArrowLeft className="h-4 w-4 mr-2" /> Contact Us</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
